const teachers = {
  pageTitle: 'शिक्षक',
  number: '#',
  teacher: 'शिक्षक',
  role: 'भूमिका',
  class: 'कक्षा',
  students: 'छात्र',
  joiningDate: 'कार्यभार ग्रहण तिथि',
  contact: 'संपर्क',
  status: 'स्थिति',
  active: 'सक्रिय',
  onLeave: 'छुट्टी पर',
  inactive: 'निष्क्रिय',
  searchTeachers: 'शिक्षक खोजें...',
  allClasses: 'सभी कक्षाएं',
  allRoles: 'सभी भूमिकाएं',
  filtered: 'फ़िल्टर किया गया',
  step1Label: 'प्रोफ़ाइल',
  step2Label: 'नियुक्ति',
  step1Title: 'शिक्षक प्रोफ़ाइल',
  step2Title: 'कक्षा और नियुक्ति विवरण',
  onboardTeacher: 'शिक्षक ऑनबोर्ड करें',
  enterFullName: "शिक्षक का पूरा नाम दर्ज करें",
  selectRole: 'भूमिका चुनें',
  fullResidentialAddress: 'पूरा आवासीय पता',
  selectClassSection: 'कक्षा अनुभाग चुनें',
  profileSummary: 'प्रोफ़ाइल सारांश',
  assignmentSummaryPrefix: 'को नियुक्त किया गया',
  joiningPrefix: 'कार्यभार ग्रहण',
  completeFieldsPrompt: 'नियुक्ति सारांश देखने के लिए ऊपर के फ़ील्ड पूरे करें।',
  editTeacher: 'शिक्षक संपादित करें',
  profileInformation: 'प्रोफ़ाइल जानकारी',
  assignmentDetails: 'नियुक्ति विवरण',
  studentsAssigned: '{{count}} छात्र नियुक्त',
  studentsAssignedPlural: '{{count}} छात्र नियुक्त',
  teacherHasStudents: 'इस शिक्षक के {{className}} में {{count}} छात्र हैं',
  teacherHasStudentsPlural: 'इस शिक्षक के {{className}} में {{count}} छात्र हैं',
  viewStudents: 'छात्र देखें',
  noStudentsEnrolled: 'अभी तक कोई छात्र नामांकित नहीं',
  saveChanges: 'परिवर्तन सहेजें',
  deactivate: 'निष्क्रिय करें',
  reactivateTeacher: 'शिक्षक को पुनः सक्रिय करें',
  reactivateConfirm: '{{name}} को पुनः सक्रिय करें?',
  noTeachersFound: 'कोई शिक्षक नहीं मिला',
};

export default teachers;